import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {EnvironmentProviders, Injectable, makeEnvironmentProviders} from '@angular/core';
import {DateFnsAdapter} from '@angular/material-date-fns-adapter';
import {enUS} from 'date-fns/locale';

export const MX_DATE_FORMATS: MatDateFormats = {
  parse: {dateInput: 'MM/dd/yyyy'},
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'MM/dd/yyyy',
    monthYearA11yLabel: 'MM yyyy',
  }
};

@Injectable({providedIn: 'root'})
export class MxDateFnsAdapter extends DateFnsAdapter {
  // This is used to display one-letter days in the date picker calendar header (instead of the default 'Su', 'Mo', 'Tu', etc.).
  public override getDayOfWeekNames(): string[] {
    return ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  }
}

export function provideAviaryDateDefaults(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: DateAdapter, useClass: MxDateFnsAdapter},
    {provide: MAT_DATE_LOCALE, useValue: enUS},
    {provide: MAT_DATE_FORMATS, useValue: MX_DATE_FORMATS}
  ]);
}
